import React from 'react';
import {connect} from 'react-redux';
import {compose} from 'recompose';
import {getKeycloakAccountUrl} from '../shared/tokenFunctions';
import FuseTheme from '../global/theme';
import FlatButton from 'material-ui/FlatButton';
import PersonIcon from 'material-ui/svg-icons/action/account-circle';

const accountButtonStyles = {
    color: FuseTheme.palette.accent2Color,
    margin: '5px 10px 0 0'
};

const AccountButton = (props) => {

    const handleClick = (e) => {
        const accountUrl = getKeycloakAccountUrl();
        window.open(accountUrl, '_blank');
    };

    const authMethod = localStorage.getItem('auth_method');

    if (!props.token || !props.tokenState || props.tokenState !== 'valid' || authMethod === 'cs') {
        return null
    }

    return (
        <FlatButton
            default
            icon={<PersonIcon/>}
            label="Account"
            onClick={handleClick}
            hoverColor={FuseTheme.palette.lightCanvasColor}
            style={accountButtonStyles}
        />
    )
};

const mapStateToProps = (state, ownProps) => {
    let form = state.form['tokenForm'];
    if (form && form.values) {
        const tokenValue = (form.values['token']) ? form.values['token'] : null;
        const tokenState = sessionStorage.getItem('token_state');
        return {
            token: tokenValue,
            tokenState: tokenState
        }
    }
    return {token: null}
};

const enhance = compose(
    connect(mapStateToProps)
);

export default enhance(AccountButton);



// WEBPACK FOOTER //
// ./src/Fuse/buttons/AccountButton.js